import { z } from 'zod';

// Never validated or submitted: it exists because `Textarea` reads its value from a form.
export const ChatEmailFormSchema = z.object({
  body: z.string().nullish(),
});

export type ChatEmail = z.infer<typeof ChatEmailFormSchema>;
